import React from 'react';
import BaseTabComponent from './../BaseTabComponent';
import plusIcon from "../../../../svgs/plus-button.svg";
import minusIcon from "../../../../svgs/minus-button.svg";
import {getExpensesHeader} from "../../mt-fields-to-save";
import Icon from "../../../Icon";
import {analysisTableValueIndex, expensesValueIndex, pricingCurrentValueIndex, pricingProformaPercentIndex, pricingProformaValueIndex} from "../../utils";

export default class Pricing extends BaseTabComponent {
    constructor(props) {
        super(props);

        this.handleExpand = this.handleExpand.bind(this);
    }

    handleExpand(isAdditionalPrice) {
        if (isAdditionalPrice) {
            this.props.handleExpand({
                tabId: 'pricing-tab',
                tablesId: ['base-rent'],
                rowsId: {
                    'base-rent': ['additional-price'],
                },
            });
            this.props.setState({isAdditionalPriceVisible: !this.props.isAdditionalPriceVisible});
        } else {
            this.props.handleExpand({
                tabId: 'pricing-tab',
                tablesId: ['header', 'base-rent', 'exp-reimb', 'total-gross-revenue', 'expenses', 'net-operating-income', 'annual-debt-service', 'value', 'down-payment', 'loan-amount', 'interest-rate', 'principal-balance-rate','proforma-capital-req'],
                rowsId: {
                    'base-rent': ['header', 'occupied-space', 'vacant-space'],
                },
                cellsId: [4, 5, 6, 7, 8]
            });
            this.props.setState({isProformaVisiblePricing: !this.props.isProformaVisiblePricing});
        }
    }

    onTableValueChange(tableIdentifier, rowCode, event, columnIndex, precomputedValues) {
        if(tableIdentifier === 'pricing-analysis' && rowCode === 'assumable-loan-checkbox' && columnIndex === analysisTableValueIndex){
            this.props.valueChange({
                tab: 'pricing-tab',
                table: tableIdentifier,
                row: rowCode,
                value: event.currentTarget.checked,
                columnIndex: columnIndex,
                assumableLoanPricingViewChange: true,
            });
            return;
        }
        
        if(tableIdentifier === 'principal-balance-rate'  &&  rowCode === 'principal-balance' && columnIndex === pricingCurrentValueIndex){
            const price = precomputedValues.pricingValue;
            this.props.valuesChange({
                tabs: ['pricing-tab', 'pricing-tab', 'pricing-tab', 'pricing-tab'],
                tables: [tableIdentifier, 'down-payment', 'down-payment', 'principal-balance-rate'],
                rowIds: [rowCode, 'down-payment', 'down-payment', 'principal-balance'],
                values: [event.currentTarget.value, price - parseInt(event.currentTarget.value), price - parseInt(event.currentTarget.value), event.currentTarget.value],
                columnIds: [columnIndex, pricingCurrentValueIndex, pricingProformaValueIndex, pricingProformaValueIndex],
            });
            return;
        }

        if(tableIdentifier === 'interest-rate' && rowCode === 'principal-balance-rate' && columnIndex === pricingProformaValueIndex){
            const price = precomputedValues.pricingValue;
            this.props.valuesChange({
                tabs: ['pricing-tab', 'pricing-tab'],
                tables: [tableIdentifier, 'down-payment'],
                rowIds: [rowCode, 'down-payment'],
                values: [event.currentTarget.value, price - parseInt(event.currentTarget.value)],
                columnIds: [columnIndex, pricingProformaValueIndex],
            });
            return;
        }

        if((tableIdentifier === 'loan-amount' && rowCode === 'loan-amount') || (tableIdentifier === 'down-payment' && rowCode === 'down-payment') && columnIndex === pricingCurrentValueIndex){
            this.props.valuesChange({
                tabs: ['pricing-tab', 'pricing-tab'],
                tables: [tableIdentifier, tableIdentifier],
                rowIds: [rowCode, rowCode],
                values: [event.currentTarget.value, event.currentTarget.value],
                columnIds: [columnIndex, pricingProformaValueIndex],
            });
            return;                
        }

        if(tableIdentifier === 'down-payment' && rowCode === 'down-payment' && columnIndex === pricingProformaPercentIndex){
            this.props.valuesChange({
                tabs: ['pricing-tab', 'pricing-tab'],
                tables: [tableIdentifier, tableIdentifier],
                rowIds: [rowCode, rowCode],
                values: [event.currentTarget.value, event.currentTarget.value],
                columnIds: [columnIndex, analysisTableValueIndex],
            });
            return;                
        }

        if (tableIdentifier === 'pricing-analysis' && rowCode === 'pricing-analysis' && columnIndex === analysisTableValueIndex) {
            this.props.valuesChange({
                tabs: ['pricing-tab', 'expenses-tab', 'pricing-tab',],
                tables: [tableIdentifier, 'expenses', tableIdentifier],
                rowIds: [rowCode, 'header', rowCode],
                values: [event.currentTarget.value, getExpensesHeader({pricingAnalysis: event.currentTarget.value}), event.currentTarget.value],
                columnIds: [columnIndex, expensesValueIndex, 2],
            });
            return;
        }

        if (tableIdentifier === 'pricing-analysis' && rowCode === 'pricing-analysis' && columnIndex === analysisTableValueIndex) {
            this.props.valuesChange({
                tabs: ['pricing-tab', 'expenses-tab'],
                tables: [tableIdentifier, 'expenses'],
                rowIds: [rowCode, 'header'],
                values: [event.currentTarget.value, getExpensesHeader({pricingAnalysis: event.currentTarget.value})],
                columnIds: [columnIndex, expensesValueIndex],
            });
            return;
        }

        if (tableIdentifier === 'pricing-analysis' && ['as-is-checkbox', 'proforma-checkbox'].includes(rowCode) && columnIndex === analysisTableValueIndex) {
            this.props.valuesChange({
                tabs: ['pricing-tab', 'pricing-tab'],
                tables: [tableIdentifier, tableIdentifier],
                rowIds: [rowCode, rowCode === 'as-is-checkbox' ? 'proforma-checkbox' : 'as-is-checkbox'],
                values: [event.currentTarget.checked, !event.currentTarget.checked],
                columnIds: [columnIndex, columnIndex],
                proformaPricingViewChange: true,            
                isProformaPricing: rowCode === 'proforma-checkbox' && event.currentTarget.checked,
            });
            return;
        }

        this.props.valueChange({
            tab: 'pricing-tab',
            table: tableIdentifier,
            row: rowCode,
            value: event.currentTarget.value,
            columnIndex,
        });
    }
    getValue(){
        const proformaValue =this.props.tabs['pricing-tab'].tables['pricing-analysis'].rows['pricing-analysis'].valueCells[2].value;
        
        return proformaValue ? proformaValue : '';
    }

    renderMatrixTable(tables, tableIdentifier, precomputedValues, hasProformaExpansion = false, nonReimbExpenses) {
        const table = tables[tableIdentifier];       
        const tableRows = Object.keys(table.rows).map((key) => {
            const row = table.rows[key];
            const nameCell = BaseTabComponent.renderNameCell(row);
            if (tableIdentifier === 'expenses' && key === 'non-reimbursable-expenses' && !nonReimbExpenses)
                return;

            return <tr key={key} className={key}>
                {table.hasNamesColumn ? nameCell : null}

                {row.valueCells.map((cell, index) => {
                    if (cell === null) {
                        return <td key={index} className='invisible'/>
                    }
                    if (cell.hidden) {
                        return;
                    }
                    if (cell.editable) {
                        return this.renderEditableValueCell(tableIdentifier, key, cell, index, precomputedValues);
                    }
                    else {
                        const domKey = `${key}-${index}`;
                        return this.renderStaticValueCell(this.props.tabs, cell, domKey, precomputedValues, tableIdentifier);
                    }
                })}
            </tr>
        });

        return (
            <React.Fragment key={tableIdentifier}>
                <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
                    <tbody>
                    {table.headerRow && table.headerRow.length ?
                        <tr>{table.headerRow.map((cell, index) => {
                            return (
                                <td className='header-cell' key={index}>
                                    <div className='text'>{cell}</div>
                                </td>
                            )
                        })}</tr>
                        : null
                    }

                    {tableRows}
                    {table.footerRow && table.footerRow.valueCells && table.footerRow.valueCells.length ?
                        <tr className='footer-row'>{Object.keys(table.footerRow.valueCells).map((key) => {
                            const cell = table.footerRow.valueCells[key];
                            if (cell.hidden) {
                                return;
                            }
                            if (cell) {
                                return (
                                    <td key={key}>
                                        <div className='text'>{cell.getComputedValue(this.props.tabs, precomputedValues).displayValue}</div>
                                        {cell.tooltip ? <span className='cell-tooltip'>{cell.tooltip}</span> : null}
                                    </td>
                                );
                            }
                            return <td className='invisible' key={key}/>;
                        })}</tr>
                        : null
                    }
                    </tbody>
                </table>
                {
                    hasProformaExpansion &&
                    <div className={'Financials_table_expand_button'} dangerouslySetInnerHTML={{__html: (this.props.isProformaVisiblePricing ? minusIcon : plusIcon)}} onClick={() => this.handleExpand()}/>
                }
                {
                    hasProformaExpansion && this.props.isProformaVisiblePricing && <div className={'Financials_proforma'}>
                        <input class="" placeholder="MM/DD/YYYY" onChange={(e)=>{
                            this.onTableValueChange("pricing-analysis","pricing-analysis",e,2,precomputedValues)
                        }} value={this.getValue()}/>
                    </div>
                }
            </React.Fragment>
        )
    }

    renderStaticValueCell(tabs, cell, domKey, precomputedValues,tableIdentifier) {
        const negativeRedText = ['pricing-sensitivity-matrix','pricing-sensitivity-matrix-pro'].includes(tableIdentifier) && cell.getComputedValue(tabs, precomputedValues).displayValue && cell.getComputedValue(tabs, precomputedValues).displayValue.includes("(")
        return (
            <td className={`value-cell ${(cell.styleClasses && cell.styleClasses.length ? cell.styleClasses : '')}`} key={domKey}>
                <span className='text value' style={{color:negativeRedText ?'red':''}}>{cell.getComputedValue(tabs, precomputedValues).displayValue}</span>
                {
                    cell.hasExpandButton &&
                    <span className='expand-button' onClick={() => this.handleExpand(true)}>
                        <Icon svg={this.props.isAdditionalPriceVisible ? minusIcon : plusIcon}/>
                    </span>
                }
                {cell.tooltip ? <span className='cell-tooltip'>{cell.tooltip}</span> : null}
            </td>
        );
    }

    render() {
        const tab = this.props.tabs['pricing-tab'];
        const generalInformation = this.props.tabs['property-information-tab'].tables['general-information'];
        const nonReimbExpenses = this.props.tabs['expenses-tab'].tables['expenses'].rows['non-reimbursable-expenses'].valueCells[pricingCurrentValueIndex].value;
        // Computing heavily-used values at the start of the render.
        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.props.tabs);
        const isProformaChecked = tab.tables['pricing-analysis'].rows['proforma-checkbox'].valueCells[1].value
        const isCurrentChecked = tab.tables['pricing-analysis'].rows['as-is-checkbox'].valueCells[1].value
        return (
            <div className="Pricing">
                <div className="Financials_table_container">
                    <h3 className="Financials_table_title">{generalInformation.rows['property-name'].value}</h3>
                    <div className="text">{generalInformation.rows['address'].value}</div>
                    <div className="text">{generalInformation.rows['city'].value}, {generalInformation.rows['state'].value}</div>
                </div>

                <div className='Financials_list_columns'>
                    <div className={`Financials_list_column ${this.props.isProformaVisiblePricing ? 'expanded' : ''}`}>
                        {BaseTabComponent.renderTableContainer(tab.tables['pricing-analysis'], [
                            this.renderMatrixTable(tab.tables, 'pricing-analysis', precomputedValues, true),
                            this.renderMatrixTable(tab.tables, 'header', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'base-rent', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'exp-reimb', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'total-gross-revenue', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'expenses', precomputedValues, null, nonReimbExpenses),
                            this.renderMatrixTable(tab.tables, 'net-operating-income', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'annual-debt-service', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'value', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'down-payment', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'principal-balance-rate', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'interest-rate', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'loan-amount', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'proforma-capital-req', precomputedValues),
                        ])}
                    </div>
                    <div className='Financials_list_column'>
                        {
                            isCurrentChecked &&
                            BaseTabComponent.renderTableContainer(tab.tables['pricing-sensitivity-matrix'], [
                                this.renderMatrixTable(tab.tables, 'pricing-sensitivity-matrix', precomputedValues),
                                this.renderTable(tab.tables, 'pricing-sensitivity-matrix-increase', precomputedValues)
                        ])}
                        {
                            isProformaChecked &&
                            BaseTabComponent.renderTableContainer(tab.tables['pricing-sensitivity-matrix-pro'], [
                            this.renderMatrixTable(tab.tables, 'pricing-sensitivity-matrix-pro', precomputedValues),
                            this.renderTable(tab.tables, 'pricing-sensitivity-matrix-increase-pro', precomputedValues)
                        ])}
                    </div>
                </div>
            </div>
        )
    }
}